export default __webpack_public_path__ + "static/media/third-party-data-consent-en-1.738abb00.jpg";